import 'common/utils/firebase/init'
import 'common/styles/index.scss'
import '@/styles/index.scss'
import { initDayjsUtils } from 'common/utils/datetime'
import store from 'common/store'
import router from 'common/router'
import { createApp } from 'vue'
import App from './app.vue'
import { logNotRequestApi } from 'common/utils/firebase/utils'

const app = createApp(App)

logNotRequestApi()

initDayjsUtils()

app.use(store).use(router)
app.mount('#app')
